export default "__VITE_ASSET__Di3vNp6p__"